import { EditableGrid } from "./EditableGrid"
import { classic_coords } from "./utils"

export const EditablePanel = ({
  size,
  animations,
  el,
  ships = [],
  setShips,
  orientation,
  holding,
  setHolding,
  cleanGrid,
  selected,
  setSelected
}) => {
  // coordenadas genericas
  const coords = classic_coords(size)

  return (
    <>
      <div className="row"></div>
      <div className="row">
        <div className="y-coord-col"></div>
        <div className="game-grid-container">
          <div className="x-coord-row pb-3">
            {coords.xcoords.map((col, cix) => (
              <div key={cix} className="coord-text">
                {col}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="y-coord-col">
          {coords.ycoords.map((row, rix) => (
            <div key={rix} className="row coord-text">
              {row}
            </div>
          ))}
        </div>

        <div className="game-grid-container" ref={el}>
          <EditableGrid
            coords={coords}
            animations={animations}
            size={size}
            orientation={orientation}
            holding={holding}
            setHolding={setHolding}
            ships={ships}
            cleanGrid={cleanGrid}
            setShips={setShips}
            selected={selected}
            setSelected={setSelected}
          />
        </div>
      </div>
    </>
  )
}
